import { render, staticRenderFns } from "./ConfirmRegistrationForm.vue?vue&type=template&id=4be7910d&scoped=true&lang=pug&"
import script from "./ConfirmRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./ConfirmRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmRegistrationForm.vue?vue&type=style&index=0&id=4be7910d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be7910d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
